import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function L() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('RV');
    const { locale, query } = useRouter();

    const salePhase3Time = '2025/05/19 15:00:00 GMT+8';

    const nowTime = query?.timer ? new Date(`${query?.timer} GMT+8`).getTime() : new Date().getTime();

    const isP3 = nowTime >= new Date(salePhase3Time).getTime() && ['us', 'ca'].includes(locale);

    const spLinks: Record<string, string> = {
        us: 'https://us.ecoflow.com/pages/shipping-policy',
        ca: 'https://ca.ecoflow.com/pages/order-processing-shipping-policy',
    };

    const checkUrl = (url: string) => {
        url = Array.isArray(url) ? url[0] : url;

        if (!url.startsWith('https')) {
            return 'https://' + url;
        } else {
            return url;
        }
    };

    return (
        <div id="RV-L" className={`RV-L RV-box ${css['RV-L']}`}>
            <p className="text">
                {t.rich(isP3 ? 'L_text_p3' : 'L_text', {
                    s: (text: string) => <span className="strong">{text}</span>,
                    a: (text: string) => (
                        <a className="link" href={`mailto:${text}`}>
                            {text}
                        </a>
                    ),
                    link: (text: string) => (
                        <a className="link" target="_blank" href={`${checkUrl(text)}`}>
                            {text}
                        </a>
                    ),
                    sp: (text: string) => (
                        <a className="link" target="_blank" href={spLinks[locale] || spLinks.us}>
                            {text}
                        </a>
                    ),
                    rp: (text: string) => (
                        <a className="link" target="_blank" href={`https://${locale}.ecoflow.com/pages/ecoflow-return-policy`}>
                            {text}
                        </a>
                    ),
                })}
            </p>
        </div>
    );
}
